export default "__VITE_ASSET__aEYhbZle__"